import React, { useState } from 'react';
import { toHumanDate, transformTimeFormatLocale } from '../../utils/data';
import { useStyles } from '../chatList/chatList.styles';
import { IProps } from './types';

export const Chat = ({ item, className, textClassName }: IProps) => {
  const [isHovered, setIsHovered] = useState(false);
  const classes = useStyles();


  const handleMouseOver = () => {
    setIsHovered(true);
  };

  const handleMouseOut = () => {
    setIsHovered(false);
  };

  return (
    <div key={item.id} className={className} onMouseOver={handleMouseOver} onMouseOut={handleMouseOut}>
      <div style={{
        display: 'flex',
      }}>
        <div className={classes.chatDate}>{toHumanDate(item.startDate, 'd MMM yyyy').slice(0, 6)}</div>
        <div className={classes.textBlock}>
          <div className={classes.chatText}>{item.name}</div>
          <div className={isHovered ? classes.isHovered : textClassName}>
            {item.organization.name}
          </div>
        </div>
      </div>
      <div className={isHovered ? classes.isHovered : textClassName}>{transformTimeFormatLocale(item.notices[item.notices.length - 1]?.createdAt)}</div>
    </div>
  );
};
